/**
 * Spawnry Tools Configuration
 * Single source of truth for tools metadata
 * Used by both client (React) and server (SSR meta injection)
 */

const toolsConfig = {
  // Main tools landing page (Spawnry has a single tool, so this is less relevant)
  landing: {
    title: 'Spawnry',
    description: 'Transform any article into audio, social posts, and summaries with AI.',
    subtitle: 'Your story, ready for all platforms'
  },

  // Individual tools
  tools: {
    'article-to-media': {
      title: 'Article to Media',
      fullTitle: 'Spawnry - Transform Articles into Audio, Social Posts & Summaries',
      description: 'Transform any article URL into an AI-generated audio summary, 3 unique social media posts with AI-generated images, and a 5-bullet TLDR summary.',
      shortDescription: 'Transform any article URL into an audio summary, social media posts with AI-generated images, and a TLDR summary.',
      path: '/',
      tech: ['Node', 'React', 'OpenAI', 'Claude Code']
    }
  }
};

module.exports = toolsConfig;
